module.exports = __webpack_public_path__ + "img/c7.c4a39768.jpg";